import React, {Component} from 'react';
import {withTranslation} from 'react-i18next';
import {reactTableText} from '../constants/configs';
import {NotificationManager} from '../components/common/react-notifications';
import ReactTableSelectFilter from "../components/ReactTableSelectFilter";
import ReactTableDateFilter from "../components/ReactTableDateFilter";
import {join, keyBy, lowerCase, mapValues, omit, map} from "lodash";
import ModalManager from "../components/modal/ModalManager";
import NotificationDetails from "./NotificationDetails";
import LoaderButton from "../components/LoaderButton";
import UserInfo from "../components/UserInfo";
import {i18nizeDate} from '../helpers/Utils';
import Rbac from '../components/Rbac';
import ReactTable from 'react-table';
import Api from '../services/Api';
import moment from "moment/moment";

class NotificationsList extends Component {
  static defaultProps = {
    showAllActions: true,
  };

  constructor(props) {
    super(props);
    this.state = {
      groupOptions: [],
      notifications: [],
      types: [],
      pages: -1,
      loading: false,
      selectedStartDate: null,
      selectedEndDate: null,
      expanded: {},
    };
    this.renderCategoryFilter = this.renderCategoryFilter.bind(this);
    this.renderTypeFilter = this.renderTypeFilter.bind(this);
    this.renderGroupFilter = this.renderGroupFilter.bind(this);
    this.renderDateFilter = this.renderDateFilter.bind(this);
    this.renderRecipientTypeFilter = this.renderRecipientTypeFilter.bind(this);
  }

  async componentDidMount() {
    await Promise.all([
      this.fetchTypes(),
      this.fetchGroups(),
    ]);
  }

  fetchGroups = async () => {
    try {
      const {data} = await Api.invoke('GET', '/v2/admin-ui/notifications/groups');
      this.setState({
        groupOptions: data.rows.map(item => ({label: item.name, value: item.name})),
      });
    } catch (e) {
      console.log("error: ", e);
    }
  };

  fetchTypes = async () => {
    const {category} = this.props;
    try {
      const {data} = await Api.invoke('GET', '/v2/admin-ui/notifications/types', null, {
        params: {
          ...(category ? {category} : null),
        },
      });
      this.setState({
        types: data.rows,
      });
    } catch (e) {
      console.log("error: ", e);
    }
  };

  fetchData = async state => {
    const {category, userId} = this.props;
    this.setState({loading: true});
    try {
      const offset = state.page * state.pageSize;
      const {data} = await Api.invoke(
        'GET',
        '/v2/admin-ui/notifications',
        null,
        {
          params: {
            offset,
            limit: state.pageSize,
            ...(category ? {category} : null),
            ...(userId ? {userId} : null),
            ...(state.filtered.length ? omit(mapValues(keyBy(state.filtered, 'id'), 'value'), 'createdAt') : null),
            ...(this.state.selectedStartDate ? {from: moment(this.state.selectedStartDate).toISOString()} : null),
            ...(this.state.selectedEndDate ? {to: moment(this.state.selectedEndDate).toISOString()} : null),
          }
        }
      );
      this.setState({
        notifications: data.rows,
        pages: Math.ceil(data.count / state.pageSize),
      });
    } catch (e) {
      console.log('error: ', e);
    } finally {
      this.setState({
        loading: false,
      });
    }
  };

  updateNotification = async (id, values) => {
    const {t} = this.props;
    try {
      await Api.invoke('PATCH', `/v2/admin-ui/notifications/${id}`, values);
      NotificationManager.success(t('Notification updated successfully'), t('Message'));
      await this.fetchData(this.table.state);
    } catch (e) {
      console.log('error: ', e);
    }
  };

  deleteNotification = async (id) => {
    const {t} = this.props;
    try {
      await Api.invoke('DELETE', `/v2/admin-ui/notifications/${id}`);
      NotificationManager.success(t('Notification deleted successfully'), t('Message'));
      await this.fetchData(this.table.state);
    } catch (e) {
      console.log('error: ', e);
    }
  };

  renderRecipientTypeFilter({filter, onChange}) {
    const {t} = this.props;
    const options = [
      {label: t('all'), value: ''},
      {label: 'GROUP', value: 'GROUP'},
      {label: 'USER', value: 'USER'},
    ];
    return <ReactTableSelectFilter
      filter={filter}
      onChange={onChange}
      options={options}
    />;
  }

  renderCategoryFilter({filter, onChange}) {
    const {t} = this.props;
    const options = [
      {label: t('all'), value: ''},
      {label: t('Announcements'), value: 'ANNOUNCEMENT'},
      {label: t('Declarations'), value: 'DECLARATION'},
      {label: t('Events'), value: 'EVENTS'},
    ];
    return <ReactTableSelectFilter
      filter={filter}
      onChange={onChange}
      options={options}
    />;
  }

  renderTypeFilter({filter, onChange}) {
    const {t} = this.props;
    const {types} = this.state;
    const options = [
      {label: t('all'), value: ''},
      ...map(types, item => ({
        label: item.type, value: item.type
      })),
    ];
    return <ReactTableSelectFilter
      filter={filter}
      onChange={onChange}
      options={options}
    />;
  }

  renderGroupFilter({filter, onChange}) {
    const {t} = this.props;
    const {groupOptions} = this.state;
    const options = [
      {label: t('all'), value: ''},
      ...groupOptions,
    ];
    return <ReactTableSelectFilter
      filter={filter}
      onChange={onChange}
      options={options}
    />;
  }

  renderDateFilter({onChange}) {
    const {selectedStartDate, selectedEndDate} = this.state;
    return <ReactTableDateFilter
      onChange={onChange}
      handleDateChange={this.handleDateChange}
      selectedStartDate={selectedStartDate}
      selectedEndDate={selectedEndDate}
    />;
  }

  handleDateChange = (type, date) => {
    this.setState({
      [type]: date,
    });
  };

  onPressPublish = (id, values) => {
    const {t} = this.props;
    ModalManager.open({
      isOpen: true,
      title: t('Confirm Publish'),
      body: t('Are you sure you want to publish {{id}} notification ?', {
        id,
      }),
      buttons: [
        {
          color: 'primary',
          onClick: async () => {
            await this.updateNotification(id, values);
            ModalManager.close({
              isOpen: false
            });
          },
          text: t('Accept'),
        },
        {
          color: 'grey',
          onClick: () => {
            ModalManager.close({
              isOpen: false
            });
          },
          text: t('Close'),
        },
      ],
    });
  };

  onPressEdit = props => {
    const {history} = this.props;
    const {category} = props.original;
    history.push(`/dashboard/notifications/${lowerCase(category)}/update`, props.original);
  };

  onPressDelete = props => {
    const {t} = this.props;
    ModalManager.open({
      isOpen: true,
      title: t('Confirm Delete'),
      body: t('Are you sure you want to delete {{id}} notification ?', {
        id: props.value,
      }),
      buttons: [
        {
          color: 'primary',
          onClick: async () => {
            await this.deleteNotification(props.value);
            ModalManager.close({
              isOpen: false
            });
          },
          text: t('Accept'),
        },
        {
          color: 'grey',
          onClick: () => {
            ModalManager.close({
              isOpen: false
            });
          },
          text: t('Close'),
        },
      ],
    });
  };

  goStats = props => {
    const {history} = this.props;
    history.push('/dashboard/notifications/stats/' + props.value);
  };

  goMessages = props => {
    const {history, userId} = this.props;
    history.push('/dashboard/notifications/messages/' + props.value, {
      userId,
    });
  };

  getColumns = t => [
    {
      Header: t('Recipient'),
      accessor: 'recipientType',
      Cell: props => {
        const {type, value} = props.original.recipient;
        if (type === "USER") {
          return (
            <UserInfo
              onClick={() => {this.props.history.push('/dashboard/users/' + value);}}
              textColor="text-success"
              label={t('User')}
              type={type}
              id={value}
            />
          );
        }
        return <span>{value}</span>;
      },
      filterable: true,
      Filter: this.renderRecipientTypeFilter,
      width: 100,
    },
    {
      Header: t('Category'),
      accessor: 'category',
      filterable: true,
      Filter: this.renderCategoryFilter,
      width: 160,
      show: !this.props.category,
    },
    {
      Header: t('Type'),
      accessor: 'type',
      filterable: true,
      Filter: this.renderTypeFilter,
      width: 200,
    },
    {
      Header: t('Groups'),
      accessor: 'groups',
      Cell: props => {
        if (props.value && props.value.length) {
          return <span>{join(props.value, ', ')}</span>;
        }
        return "----------";
      },
      filterable: true,
      Filter: this.renderGroupFilter,
      width: 140,
    },
    {
      Header: t('Status'),
      accessor: 'status',
      width: 100,
    },
    {
      Header: t('Registration Date'),
      accessor: 'createdAt',
      Cell: props => <span>{i18nizeDate(props.value)}</span>,
      filterable: true,
      Filter: this.renderDateFilter,
      width: 160,
    },
    {
      Header: t('Publish Date'),
      accessor: 'triggeredAt',
      Cell: props => <span>{props.value ? i18nizeDate(props.value) : "----------"}</span>,
      width: 140,
    },
    {
      Header: t('Expiration Date'),
      accessor: 'expiredAt',
      Cell: props => <span>{props.value ? i18nizeDate(props.value) : "----------"}</span>,
      width: 140,
    },
    {
      Header: t('Actions'),
      accessor: 'id',
      width: !!this.props.showAllActions ? 430 : 110,
      Cell: props => <div className="d-flex flex-row align-items-center">
        {!!this.props.showAllActions && props.original.status === "DRAFT" &&
          <Rbac permission='update_notification'>
            <LoaderButton
              outline
              size="sm"
              color="success"
              style={{maxWidth: 100}}
              onClick={() => {this.onPressPublish(props.value, {status: 'COMPLETED'});}}
              className="text-center mr-2 flex-1">
              {t('Publish')}
            </LoaderButton>
          </Rbac>
        }
        {!!this.props.showAllActions && props.original.category !== "EVENT" &&
          <Rbac permission='update_notification'>
            <LoaderButton
              outline
              size="sm"
              color="primary"
              style={{maxWidth: 100}}
              onClick={() => {this.onPressEdit(props);}}
              className="text-center mr-2 flex-1">
              {t('Edit')}
            </LoaderButton>
          </Rbac>
        }
        {!!this.props.showAllActions && props.original.status === "DRAFT" &&
          <Rbac permission='delete_notification'>
            <LoaderButton
              outline
              size="sm"
              color="danger"
              style={{maxWidth: 100}}
              onClick={() => {this.onPressDelete(props);}}
              className="text-center mr-2 flex-1">
              {t('Delete')}
            </LoaderButton>
          </Rbac>
        }
        {!!this.props.showAllActions && props.original.status !== "DRAFT" &&
          <Rbac permission='view_notification'>
            <LoaderButton
              outline
              size="sm"
              color="dark"
              style={{maxWidth: 100}}
              onClick={() => {this.goStats(props);}}
              className="text-center mr-2 flex-1">
              {t('View Stats')}
            </LoaderButton>
          </Rbac>
        }
        {props.original.status !== "DRAFT" && this.props.userId &&
          <Rbac permission='view_notification'>
            <LoaderButton
              outline
              size="sm"
              color="info"
              style={{maxWidth: 100}}
              onClick={() => {this.goMessages(props);}}
              className="text-center mr-2 flex-1">
              {t('Messages')}
            </LoaderButton>
          </Rbac>
        }
      </div>,
    },
  ];

  onExpanded = (newExpanded, index) => {
    this.setState({
      expanded: {
        ...this.state.expanded,
        [index[0]]: !!newExpanded[index[0]],
      },
    });
  };

  render() {
    const {t} = this.props;
    const {notifications, pages, loading, expanded} = this.state;
    return (
      <ReactTable
        manual
        ref={el => {this.table = el;}}
        className="-highlight"
        data={notifications}
        pages={pages}
        loading={loading}
        sortable={false}
        resizable={true}
        expanded={expanded}
        onExpandedChange={this.onExpanded}
        onFetchData={this.fetchData}
        columns={this.getColumns(t)}
        defaultPageSize={10}
        style={{
          width: '100%'
        }}
        {...reactTableText}
        SubComponent={({original}) => {
          return (
            <NotificationDetails notification={original}/>
          );
        }}
      />
    );
  }
}

export default withTranslation()(NotificationsList);
